import * as React from 'react';
import { Helmet } from 'react-helmet';

export default class PageMeta extends React.Component {
  render() {
    const { seo } = this.props.metaFields;

    if (!seo) {
      return null;
    }

    return (
      <React.Fragment>
        <Helmet>
          {seo.title && <title>{seo.title}</title>}
          {seo.canonical && <link rel="canonical" href={seo.canonical} />}
          {seo.metaDesc && <meta name="description" content={seo.metaDesc} />}
          {seo.opengraphTitle && (
            <meta property="og:title" content={seo.opengraphTitle} />
          )}
          {seo.opengraphDescription && (
            <meta
              property="og:description"
              content={seo.opengraphDescription}
            />
          )}
          {seo.opengraphUrl && (
            <meta property="og:url" content={seo.opengraphUrl} />
          )}
          {seo.opengraphType && (
            <meta property="og:type" content={seo.opengraphType} />
          )}
          {seo.twitterDescription && (
            <meta name="twitter:description" content={seo.twitterDescription} />
          )}
          {seo.twitterTitle && (
            <meta name="twitter:title" content={seo.twitterTitle} />
          )}
  
        </Helmet>
      </React.Fragment>
    );
  }
}
